import {lazy} from 'react';
import {RoutePaths} from './RoutePaths';
import {Authorization} from './types';
import type {BreadcrumbKind} from './lib/navigation';

const HomePage = lazy(() => import('./components/home/HomePage'));
const PeopleDirectoryPage = lazy(
    () => import('./components/people/PeopleDirectoryPage')
);
const PersonOverviewPage = lazy(
    () => import('./components/people/PersonOverviewPage')
);
const PersonTreePage = lazy(() => import('./components/people/PersonTreePage'));
const PersonPhotosPage = lazy(
    () => import('./components/people/PersonPhotosPage')
);
const TreeRedirect = lazy(() => import('./components/people/TreeRedirect'));
const PersonEditLayout = lazy(
    () => import('./components/edit/PersonEditLayout')
);
const GalleryPage = lazy(() => import('./components/gallery/GalleryPage'));
const SurnamesPage = lazy(() => import('./components/surnames/SurnamesPage'));
const SurnameDetailPage = lazy(
    () => import('./components/surnames/SurnameDetailPage')
);
const LegacyRedirect = lazy(
    () => import('./components/utility/LegacyRedirect')
);
const LoginPage = lazy(() => import('./components/accounts/LoginPage'));
const PasswordlessLoginPage = lazy(
    () => import('./components/accounts/PasswordlessLoginPage')
);

export type Page = Authorization & {
    path: string;
    component: React.LazyExoticComponent<React.ComponentType>;
    /** Drop the content panel padding so the page owns the full width. */
    fullBleed?: boolean;
    /** Static document title part; pages with dynamic titles set their own. */
    title?: string;
    /** Which trail PageBreadcrumb should build for this page. */
    breadcrumb?: BreadcrumbKind;
    // Redirect-only entry: send the visitor to this path instead of rendering a component.
    redirectTo?: string;
};

const pages: Page[] = [
    {
        path: RoutePaths.home(),
        component: HomePage,
        breadcrumb: 'home'
    },
    {
        path: RoutePaths.people.root(),
        component: PeopleDirectoryPage,
        title: 'People',
        breadcrumb: 'people'
    },
    {
        path: RoutePaths.people.treeRoute(),
        component: PersonTreePage,
        title: 'Tree',
        breadcrumb: 'person-tree'
    },
    {
        path: RoutePaths.people.photosRoute(),
        component: PersonPhotosPage,
        title: 'Photos',
        breadcrumb: 'person-photos'
    },
    {
        path: RoutePaths.people.editRoute(),
        component: PersonEditLayout,
        authorize: true,
        fullBleed: true,
        title: 'Edit',
        breadcrumb: 'person-edit'
    },
    {
        path: RoutePaths.people.detailRoute(),
        component: PersonOverviewPage,
        breadcrumb: 'person'
    },
    {
        path: RoutePaths.tree(),
        component: TreeRedirect
    },
    {
        path: RoutePaths.gallery(),
        component: GalleryPage,
        title: 'Gallery',
        breadcrumb: 'gallery'
    },
    {
        path: RoutePaths.surnames.root(),
        component: SurnamesPage,
        title: 'Surnames',
        breadcrumb: 'surnames'
    },
    {
        path: RoutePaths.surnames.detailRoute(),
        component: SurnameDetailPage,
        breadcrumb: 'surname'
    },
    {
        path: RoutePaths.accounts.login(),
        component: LoginPage,
        title: 'Login'
    },
    {
        path: RoutePaths.accounts.passwordlessLogin(),
        component: PasswordlessLoginPage,
        title: 'Login'
    },
    {
        path: RoutePaths.legacy.familyTree(),
        component: LegacyRedirect
    },
    {
        path: RoutePaths.legacy.person(),
        component: LegacyRedirect
    }
];

export default pages;
